module.exports = __webpack_public_path__ + "static/media/external-link-symbol.25908f84.svg";